import { ensureJourneyDb, getById, rowsFromIndex, updateRow } from "../../db";
import { forbidden, notFound } from "./errors";
import { resolveActor } from "./access";

/** GET /api/notifications/user/:user_id */
export function getNotificationsUser(userId, session) {
  ensureJourneyDb();
  const actor = resolveActor(session);
  if (userId !== actor.userId && !actor.isSupervisor) {
    throw forbidden("You can only view your own notifications");
  }
  const notifications = rowsFromIndex("notifications", "notificationsByUserId", userId).sort((a, b) =>
    String(b.created_at).localeCompare(String(a.created_at))
  );
  return notifications;
}

/** POST /api/notifications/mark-read */
export function postNotificationsMarkRead(body = {}, session) {
  ensureJourneyDb();
  const actor = resolveActor(session);
  const ids = body.ids || (body.notification_id ? [body.notification_id] : []);
  const updated = ids.map((id) => {
    const notification = getById("notifications", id);
    if (!notification) throw notFound("Notification not found");
    if (notification.user_id !== actor.userId && !actor.isSupervisor) {
      throw forbidden("You can only mark your own notifications read");
    }
    if (notification.is_read) return notification;
    return updateRow("notifications", id, { is_read: true });
  });
  return { updated };
}
